import { compose, hoistStatics, withProps } from 'recompose';
import { translate } from 'react-i18next';
import { connect } from 'react-redux';
import User from './User';
import UserService from '../../../../services/user.service';

const mapStateToProps = state => ({
  token: state.auth.token,
});

const enhance = compose(
  connect(mapStateToProps, null),
  translate('portal'),
  withProps((props) => {
    const src = UserService.getAvatar({ ...props.item, token: props.token });
    return { ...props, src };
  }),
);

export default hoistStatics(enhance)(User);



// WEBPACK FOOTER //
// ./src/views/modules/messages/user/index.js